<template>
  <div class="comments">
    <shadow-scroll-container id="comments-tree" ref="scroll" class="comments-tree">
      <comments-tree
        :entity="entity"
        :entity-id="entityId"
        :comments="comments"
        :can-edit="canEdit"
        :active-form="activeForm"
        @formOpened="onFormOpened"
        @commentAdded="onCommentAdded"
        @commentUpdated="onCommentUpdated"
        @commentRemoved="onCommentRemoved"
        @commentRestored="onCommentRestored"
      />
    </shadow-scroll-container>

    <div class="top-button-wrapper">
      <top-button id="comments-tree-top" class="top-button" root="#comments-tree .scroll-container" />
    </div>

    <comment-form
      v-if="canEdit"
      ref="form"
      :form-active="true"
      :active="createFormActive"
      class="comment-form"
      :pending="pending"
      @submitted="addComment"
      @closed="createFormActive = false"
    />

    <button v-if="canEdit" class="add-comment" @click="createFormActive = true">Написать комментарий</button>
  </div>
</template>

<script>
import CommentsTree from "./CommentsTree";
import CommentForm from "./AdaptiveCommentForm";

import ShadowScrollContainer from "@/components/shadow-scroll-container";
import TopButton from "@/components/top-button";

import { listToTree } from "@/utils/array/list-to-tree";

import { ADD_MESSAGE_ACTION, GET_MESSAGES_ACTION } from "./api";
import { COMMENT_ADDED } from "./events";
import { CommentModel } from "./comment-model";

export default {
  components: {
    CommentsTree,
    CommentForm,
    TopButton,
    ShadowScrollContainer,
  },

  props: ["entity", "entityId", "canEdit"],

  data() {
    return {
      loading: false,
      pending: false,
      comments: [],

      activeForm: null,

      createFormActive: false,
    };
  },

  created() {
    console.log("can edit chat", this.canEdit);
    this.load();
  },

  methods: {
    getComments() {
      return this.$store.dispatch(GET_MESSAGES_ACTION, {
        entity: this.entity,
        entityId: this.entityId,
      });
    },

    getCommentsTree(commentsList) {
      const commentsTree = listToTree(commentsList, { children: "answers" });

      function handleNode(comment) {
        const answers = comment.answers.map((answer) => handleNode(answer)).filter(Boolean);
        if (comment.deleted && !answers.length) return null;
        return {
          ...comment,
          answers,
        };
      }

      return commentsTree.map((comment) => handleNode(comment)).filter(Boolean);
    },
    load() {
      this.loading = true;
      this.getComments().then((comments) => {
        const commentsList = comments.map(CommentModel);

        this.comments = this.getCommentsTree(commentsList);
        this.loading = false;
      });
    },
    reset() {
      this.comments = [];
    },
    addComment(params) {
      this.pending = true;
      this.$store
        .dispatch(ADD_MESSAGE_ACTION, {
          entity: this.entity,
          entityId: this.entityId,
          ...params,
        })
        .then((res) => {
          if (res) {
            this.comments = [...this.comments, CommentModel(res.model)];
            this.onCommentAdded(res.model.id);
            this.$refs.form.reset();
            this.createFormActive = false;
            this.pending = false;
          } else {
            this.onError();
          }
        })
        .catch(() => {
          this.onError();
        });
    },

    deactivate() {
      this.activeForm = {
        id: null,
      };
      this.$refs.form.reset();
    },

    onError() {
      this.$notify({
        group: "center-error-message",
        data: {
          textMessage: "Произошла ошибка при отправке комментария. Попробуйте ещё раз.",
        },
      });
    },

    scrollToElement(element) {
      if (!element) return;
      element.classList.add("selected");
      element.scrollIntoView({ block: "center", behavior: "smooth" });
      setTimeout(() => {
        element.classList.remove("selected");
      }, 1000);
    },

    scrollToComment(commentId) {
      this.scrollToElement(this.$el.querySelector(`[data-comment="${commentId}"]`));
    },

    scrollToForm() {
      this.scrollToElement(this.$el.querySelector(".reply-form"));
    },

    onFormOpened(form) {
      this.activeForm = form;
      this.$nextTick(() => this.scrollToForm());
    },

    onCommentAdded(commentId) {
      this.$nextTick(() => this.scrollToComment(commentId));
    },
    onCommentUpdated(commentId) {
      this.$nextTick(() => this.scrollToComment(commentId));
    },
    onCommentRemoved() {},
    onCommentRestored() {},
  },
};
</script>

<style lang="scss" scoped>
.add-comment {
  display: none;
}

.top-button-wrapper {
  position: relative;

  .top-button {
    position: absolute;
    bottom: 5px;
  }
}

@media screen and (max-width: 700px) {
  .add-comment {
    display: block;
    height: 38px;
    color: white;
    border: none;
    background: #0066ff;
  }
  .comment-form {
    display: none;
  }
}

.comments-tree {
  /deep/ {
    .scroll-container__content {
      min-height: 100%;
      display: flex;
      flex-direction: column;
    }
    .empty {
      flex-grow: 1;
    }
  }
}
</style>
